import genericAttributeModule from "./genericAttributeModule"
import genericAttributeView from "./genericAttributeView.html"

genericAttributeModule.config(["editionServiceProvider", (editionServiceProvider) =>{
    editionServiceProvider.registerEdition("generic-attribute", genericAttributeView, "genericAttributeController")
}])